import { LEAD_CARE_MANAGER, BULK_DELETE, ZIP_CODES } from "constants/endpoints";
import { result } from "lodash";
import { deleteApi, get, post, put } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";

export const getLeadCareManagers = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    filter: obj?.status ? obj.status : "",
    key: obj?.key ? obj.key : "",
    order: obj?.order ? obj.order : "",
  };
  try {
    const result = await get(
      `${LEAD_CARE_MANAGER}?filter[status]=${params.filter}&page=${params.page}&per=${params.perPage}&query=${params.search}&sort=${params.key}&order=${params.order}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const getZipCodes = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    "filter[state_id]": obj?.state_id ? obj.state_id : "",
    "filter[county_id]": obj?.county_id ? obj.county_id : "",
    "filter[city_id]": obj?.city_id ? obj.city_id : "",
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
  };
  try {
    const result = await get(
      `${ZIP_CODES}?page=${params.page}&per=${params.perPage}&query=${params.search}&filter[state_id]=${params["filter[state_id]"]}&filter[county_id]=${params["filter[county_id]"]}&filter[city_id]=${params["filter[city_id]"]}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const createLeadCareManager = async (data, setErrors = () => {}) => {
  try {
    const result = await post(`${LEAD_CARE_MANAGER}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Care Manager created successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
export const updateLeadCareManager = async (data, id, setErrors = () => {}) => {
  console.log("data", data);
  try {
    const result = await put(`${LEAD_CARE_MANAGER}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Care Manager updated successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
export const deleteLeadCareManager = async (id) => {
  try {
    const result = await deleteApi(`${LEAD_CARE_MANAGER}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Care Manager deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "test"}
      />
    );
    console.log(result);
  }
};
export const deleteBulkLeadCareManager = async (data) => {
  try {
    const result = await put(`${LEAD_CARE_MANAGER}/${BULK_DELETE}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Care Manager deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "test"}
      />
    );
    console.log(result);
  }
};
